import React from 'react';
import RtOvwView from './RtOvwView'
import moment from 'moment';
import {compare} from '../../utils';
import {Keys, UIConstants} from "../../model/constants";
import ImmutablePropTypes from 'react-immutable-proptypes';


function getViewBoxes(views, displayMode) {
    return views
        .sort((a,b) => -compare(a.get(Keys.ID), b.get(Keys.ID)).result())
        .map( (v) => {
            return ( <RtOvwView key={v.get(Keys.ID)} view={v} displayMode={displayMode}/> )
        }).toArray();
}
function getLink(item) {
    return 'https://looklet.com/backoffice/items?q=id:'+item.get(Keys.ID)+'&menuSearchVal='+item.get(Keys.ID);
}
function getItemUrgency(item) {
    let publishDate = item.get(Keys.Item.PUBLISH_DATE);
    if(!publishDate ) {
        return ' rt-ovw--urgency-missing';
    }
    let minutesLeft=moment.duration({to:publishDate, from:moment()}).asMinutes();
    if(minutesLeft < 0) {
        return ' rt-ovw--urgency-late';
    }
    if(minutesLeft < 90) {
        return ' rt-ovw--urgency-urgent';
    }
    if(minutesLeft < 180) {
        return ' rt-ovw--urgency-medium';
    }
    if(minutesLeft < 180) {
        return ' rt-ovw--urgency-medium';
    }
    if(minutesLeft < 360) {
        return ' rt-ovw--urgency-lite';
    }
    return ' rt-ovw--urgency-none';
}


function getHeight(item) {
    let score = 1; //item.get(Keys.Item.DIFFICULTY_SCORE);
    let viewCount = item.get(Keys.Item.VIEW_COUNT);
    let ghostCount = item.get(Keys.Item.GHOST_COUNT);
    let displayCount = item.get(Keys.Item.DISPLAY_COUNT);
    return (6+1)*(viewCount+ghostCount)+(3+1)*displayCount-1;
}
class RtOvwItem extends React.Component {

    constructor(props) {
        super(props)
        this.handleOver = this.handleOver.bind( this);
    }

    handleOver(event) {
        this.props.handleOver(this.element, this.props.item)
    }
    getDisplayClass(base) {
        return base+" "+base+'--'+this.props.displayMode;
    }

    render() {
        const item = this.props.item;
        const displayMode = this.props.displayMode;
        let views = item.get(Keys.Item.VIEWS);
        let displays = item.get(Keys.Item.DISPLAYS);
        const customerId = item.get(Keys.Item.CUSTOMER)
        const disImageSrc = encodeURIComponent(JSON.stringify(
            [{
                name:"src",
                url:item.get(Keys.Item.PREVIEW_URL)
            }
        ]
        ));

        const disImageCmd = encodeURIComponent(JSON.stringify([{name:"resize",width:82,height:100}]));
        const disImageOutput=encodeURIComponent(JSON.stringify({format:"jpg"}));
        const disUrl = `https://dis.looklet.com/?input=${disImageSrc}&command=${disImageCmd}&output=${disImageOutput}&customer=${customerId}`
        const getImage = () =>
            displayMode!==UIConstants.RT_OVW_COMPACT
                ?(<div className={this.getDisplayClass("rt-ovw__item-image")}><div className="rt-ovw__item-image-background"><img src={disUrl} /></div></div>)
                :null;
        const getItemViews = () =>
                (<div className={this.getDisplayClass("rt-ovw__view-list")}> { getViewBoxes(views.concat(displays), displayMode) } </div>);
        const getPopover = () => displayMode!==UIConstants.RT_OVW_FULL?(
            <div className="rt-ovw__popover">
                <div className="rt-ovw__popover-content">
                    <a href={ getLink(item) } target="_blank"> {item.get(Keys.ID)}</a>
                </div>
            </div>
        ):null;

        const getItemData = () => {
            if(displayMode!==UIConstants.RT_OVW_FULL) {
                return null;
            } else {
                const publishDate =item.get(Keys.Item.PUBLISH_DATE);

                const date = publishDate?publishDate.local().format('YYYY-MM-DD'):'-';
                const time = publishDate?publishDate.local().format('HH:mm (Z)'):'-';
                return(
                    <div className="rt-ovw__item-data">
                        <a href={ getLink(item) } target="_blank"> {item.get(Keys.ID)}</a><br />
                        {"" + item.get(Keys.Item.CATEGORY)}<br />
                        {"" + item.get(Keys.Item.CUSTOMER)}<br />
                        {date}<br />
                        {time}
                </div>)
            }
        };

        return (
            <div ref={(ref) => {this.element = ref}} className={this.getDisplayClass("rt-ovw__item")} >
                {getImage()}
                {getItemViews()}
                <div className={this.getDisplayClass("rt-ovw__item-info")+getItemUrgency(item)}>&nbsp;</div>
                {getItemData()}
                {getPopover()}
            </div>)

    }

}
RtOvwItem.propTypes = {
    item:ImmutablePropTypes.map.isRequired,
    handleOver:React.PropTypes.func.isRequired,
    displayMode:React.PropTypes.string.isRequired,
}

export default RtOvwItem;




// WEBPACK FOOTER //
// ./src/ui/components/RtOvwItem.js